class ContributorController {
    constructor($state) {
        this.name = 'contributor'
        this.$state = $state
    }

    $onInit () {
        const scope = this

        $('.contributor').mouseup((e) => {
            const step1 = $('.contributor .step1')
            const mobileStep1 = $('.contributor .contributor-mobile-step1')
            const step2 = $('.contributor .step2')
            const mobileStep2 = $('.contributor .contributor-mobile-step2')

            // if the target of the click isn't the container nor a descendant of the container
            if (
                (!step1.is(e.target) && step1.has(e.target).length === 0) &&
                (!mobileStep1.is(e.target) && mobileStep1.has(e.target).length === 0) &&
                (!step2.is(e.target) && step2.has(e.target).length === 0) &&
                (!mobileStep2.is(e.target) && mobileStep2.has(e.target).length === 0)
            ) {
                scope.goHome()
            }
        })
    }

    goHome () {
        this.$state.go('home')
    }
}

ContributorController.$inject = ['$state']

export default ContributorController



// WEBPACK FOOTER //
// ./client/app/components/home/contributor/contributor.controller.js